export const colors = [
    "#A5C9CA",
    "#EEB76B",
    "#726A95",
    "#719FB0",
    "#A0C1B8",
    "#EEB0B0",
    "#F87474",
    "#FFB562",
    "#FFCC8F",
    "#EEB0B0",
    "#BDE6F1",
    "#FFE59D",
    "#B689C0",
    "#DFDFDE",
    "#F68989",
    "#96CEB4",
];